export const CHANGE_DIRECTION = {
  UP: 'up',
  DOWN: 'down'
};
